const Validator = require('validatorjs');
import translationsStore from '../../stores/translationsStore';
import passwordPoliciesStore from '../../stores/passwordPoliciesStore';

class CommonValidator {

    validate(data, rules, errorMessages) {

        const validation = new Validator(data, rules, errorMessages);
        validation.passes();

        return validation;
    }

    genericRangeString(str, max = 500) {

        const data = {
            str: str
        };

        const rules = {
            str: `max:${max}`
        };

        const errorMessages = {
            required: translationsStore.translate('GENERIC_REQUIRED_FILED_ERROR_MESSAGE'),
            max: {
                string: `${translationsStore.translate('MAX_LENGTH_OF_IS')} ${max}`
            }
        };

        return this.validate(data, rules, errorMessages);
    }

    validateInteger(number) {

        const data = {
            number: number
        };

        const rules = {
            number: 'required|integer'
        };

        const errorMessages = {
            required: translationsStore.translate('GENERIC_REQUIRED_FILED_ERROR_MESSAGE'),
            integer: translationsStore.translate('DIGITS_ONLY')
        };

        return this.validate(data, rules, errorMessages);
    }

    validateGenericRequiredFieldWithConcreteName(fieldName, fieldValue) {

        const data = {
            [fieldName]: fieldValue
        };

        const rules = {
            [fieldName]: 'required'
        };

        const errorMessages = {
            required: translationsStore.translate('GENERIC_REQUIRED_FILED_ERROR_MESSAGE')
        };

        return this.validate(data, rules, errorMessages);
    }

    validateUsernameField(fieldName, fieldValue) {

        const pass = /^(([a-z]|[A-Z]|[0-9]|_|-|\.|\+|@)+)$/g.test(fieldValue);

        const data = {
            [fieldName]: fieldValue
        };

        const rules = {
          [fieldName]: `required|regex:/${pass ? '.+' : '^$' }/`
        };

        const errorMessages = {
            required: translationsStore.translate('GENERIC_REQUIRED_FILED_ERROR_MESSAGE'),
            regex: translationsStore.translate('INVALID_USER_NAME').replace('{0}', fieldValue)
        };

        return this.validate(data, rules, errorMessages);
    }

    validateGenericRequiredFieldWithRestrictedChars(fieldName, fieldValue) {

        const data = {
            [fieldName]: fieldValue
        };

        const rules = {
            [fieldName]: 'required|regex:/^((?![=+@\t\r-]).).*$/'
        };

        const errorMessages = {
            required: translationsStore.translate('GENERIC_REQUIRED_FILED_ERROR_MESSAGE'),
            regex: translationsStore.translate('INVALID_CHARS')
        };

        return this.validate(data, rules, errorMessages);
    }

    validateGenericRequiredField(field) {

        return this.validateGenericRequiredFieldWithConcreteName('field', field);
    }

    validatePort(port) {

        const data = {
            port: port
        };

        const rules = {
            port: `required|integer|between:1,65535`
        };

        const errorMessages = {
            required: translationsStore.translate('GENERIC_REQUIRED_FILED_ERROR_MESSAGE'),
            integer: translationsStore.translate('GENERIC_NUMERIC_VALUE_ERROR_MESSAGE'),
            between: translationsStore.translate('PORT_RANGE_MESSAGE')
        };

        return this.validate(data, rules, errorMessages);
    }

    validateEmail(email) {

        const data = {
            email: email
        };

        const rules = {
            email: `required|regex:/^[^@]+@[^@]+$/i`
        };

        const errorMessages = {
            required: translationsStore.translate('GENERIC_REQUIRED_FILED_ERROR_MESSAGE'),
            regex: translationsStore.translate('INVALID_EMAIL')
        };

        return this.validate(data, rules, errorMessages);
    }

    validateRequiredPassword(password) {
        
        const data = {
            password: password
        };
        
        const rules = {
            password: `required`
        };

        const errorMessages = {
            required: translationsStore.translate('GENERIC_REQUIRED_FILED_ERROR_MESSAGE')
        };

        return this.validate(data, rules, errorMessages);
    }

    validateNumericField(fieldValue) {

        const data = {
            field: fieldValue
        };

        const rules = {
            field: `required|integer|between:0,65535`
        };

        const errorMessages = {
            required: translationsStore.translate('GENERIC_REQUIRED_FILED_ERROR_MESSAGE'),
            integer: translationsStore.translate('GENERIC_NUMERIC_VALUE_ERROR_MESSAGE'),
            between: translationsStore.translate('GENERIC_VALUE_RANGE_MESSAGE')
        };

        return this.validate(data, rules, errorMessages);
    }

    validateRecoveryCodeCount(fieldValue) {

        const data = {
            field: fieldValue
        };

        const rules = {
            field: `required|integer|between:1,10`
        };

        const errorMessages = {
            required: translationsStore.translate('GENERIC_REQUIRED_FILED_ERROR_MESSAGE'),
            integer: translationsStore.translate('GENERIC_NUMERIC_VALUE_ERROR_MESSAGE'),
            between: translationsStore.translate('RECOVERY_CODE_RANGE_ERROR')
        };

        return this.validate(data, rules, errorMessages);
    }

    validateUrl = url => {

        const data = {
            url: url
        };

        const rules = {
            url: ['regex:/^https?:\/\/[^ ]+$/i']
        };

        const errorMessages = {
            url: translationsStore.translate('INVALID_URL')
        };

        return this.validate(data, rules, errorMessages);
    }

    validatePassword(data) {
        var uppercaseErrorMessage = translationsStore.translateWithArguments('PASSWORD_RESTRICTION_UPPERCASE', [passwordPoliciesStore.complexity.minNoOfUpperChars]);
        var lowercaseErrorMessage = translationsStore.translateWithArguments('PASSWORD_RESTRICTION_LOWERCASE', [passwordPoliciesStore.complexity.minNoOfLowerChars]);
        var symbolErrorMessage = translationsStore.translateWithArguments('PASSWORD_RESTRICTION_CONTAIN_SYMBOL', [passwordPoliciesStore.complexity.minNoOfSpecialChars]);
        var numberErrorMessage = translationsStore.translateWithArguments('PASSWORD_RESTRICTION_CONTAIN_NUMBER', [passwordPoliciesStore.complexity.minNoOfDigits]);

        Validator.register('at_least_one_uppercase', function (value, requirement, attribute) {
            var regUppercase = '(.*[A-Z].*){' + passwordPoliciesStore.complexity.minNoOfUpperChars + ',}';
            return value.match(regUppercase);
        }, uppercaseErrorMessage);

        Validator.register('at_least_one_lowercase', function (value, requirement, attribute) {
            var regLowerCase = '(.*[a-z].*){' + passwordPoliciesStore.complexity.minNoOfLowerChars + ',}';
            return value.match(regLowerCase);
        }, lowercaseErrorMessage);

        Validator.register('contain_symbol', function (value, requirement, attribute) {
            var regSymbol = '(.*[?!|<>~:;,\\\\"/\'\\[\\]\\{\\}\\(\\)@#$%\^&*)(+=._-].*){' + passwordPoliciesStore.complexity.minNoOfSpecialChars + ',}';
            return value.match(regSymbol);
        }, symbolErrorMessage);

        Validator.register('contain_number', function (value, requirement, attribute) {
            var regNum = '(.*\\d.*){' + passwordPoliciesStore.complexity.minNoOfDigits + ',}';
            return value.match(regNum);
        }, numberErrorMessage);

        const ruleSet = {
            password: ['required', 'min:' + passwordPoliciesStore.complexity.minPasswordLength, 'at_least_one_uppercase', 'at_least_one_lowercase', 'contain_symbol', 'contain_number']
        };

        const errorMessages = {
            'required': translationsStore.translate('GENERIC_REQUIRED_FILED_ERROR_MESSAGE'),
            'min': translationsStore.translateWithArguments('PASSWORD_RESTRICTION_CHARACTER_LIMIT', [passwordPoliciesStore.complexity.minPasswordLength]),
            'at_least_one_uppercase': uppercaseErrorMessage,
            'at_least_one_lowercase': lowercaseErrorMessage,
            'contain_symbol': symbolErrorMessage,
            'contain_number': numberErrorMessage
        };

        const validation = new Validator(data, ruleSet, errorMessages);
        validation.passes();

        return validation;
    }
}

export default new CommonValidator();



// WEBPACK FOOTER //
// ./src/services/validations/commonValidators.js